const ACTION_CODES: Record<string, string> = {
  VIEW_DETAILS: 'view-details',
  UPDATE_STATE: 'update-state',
  SCHEDULE_ACTIVITY: 'schedule-activity',
  VO_SCHEDULE_ACTIVITY: 'vo-schedule-activity',
  BROWSER: 'browser',
};

const ACTIVITY_ACTIONS: Record<string, string> = {
  MAIN: 'main',
  LEADS: 'leads',
  CALENDAR_ITEM: 'calendar_item',
};

const ACTIVITY_MAIN_ACTION_CODES: Record<string, string> = {
  LEADS: 'leads',
  TASK: 'task',
  CALENDAR: 'calendar',
  BACKLOGS: 'backlogs',
  BROWSER: 'browser',
};

const CTA_HANDLER = {
  ACTION_CODES,
  ACTIVITY_ACTIONS,
  ACTIVITY_MAIN_ACTION_CODES,
};

const DEFAULT_LIMIT = 5;
const FULL_LIMIT = 50;

export const DEFAULT_PARAMS = { limit: DEFAULT_LIMIT, with: 'tier' };
export const FULL_PARAMS = { limit: FULL_LIMIT, with: 'tier' };

export default CTA_HANDLER;

export const spgWidgetCodes = ['marketing_home', 'quick_access_home'];
